import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  OnDestroy,
  OnInit,
  ViewChild,
  ViewEncapsulation,
} from "@angular/core";
import { Router } from "@angular/router";
import {
  ActionSheetController,
  LoadingController,
  Platform,
} from "@ionic/angular";
import { Subscription } from "rxjs";
import { AuthService } from "src/app/public/auth/auth.service";
import { DictionaryService } from "../../dictionary";
import { HeaderModel } from "../../_component/header/header.model";
import { PaginationClientSideOptions } from "../_component/pagination-client-side/pagination-client-side-options";
import { PaginationColumn } from "../_component/pagination-client-side/pagination-column.class";
import { Animations } from "../../_helpers/animations";
import { AppModule, Modules } from "../../_helpers/module";
import { GetBookingByUserModel } from "../../_models/booking-request.model";
import { BookingModel, BookingSection, BookingStatus } from "../../_models/booking.model";
import { GetInvitationsQuery } from "../../_models/invitations-request.model";
import { GetReportTasksModel } from "../../_models/report-task-request.model";
import { GetAssignmentsModel } from "../../_models/space-requests.model";
import { User } from "../../_models/user.model";
import { UserService } from "../../_services";
import { BookingService } from "../../_services/booking.service";
import { ConfigService } from "../../_services/config.service";
import { LoaderService } from "../../_services/loader.service";
import { ThisPlatform } from "../../_services/platform.service";
import { RowsLoaderService } from "../../_services/rows-loader.service";
import { SpaceService } from "../../_services/space.service";
import { SpaceType } from "../../_types/space-type";
import { BookingViewComponent } from "../booking/booking-view/booking-view.component";
import { Community, CommunityType } from "../community/community.model";
import { CommunityService } from "../community/community.service";
import { InvitationViewComponent } from "../invitation/invitation-view/invitation-view.component";
import { Invitation } from "../invitation/invitation.model";
import { InvitationService } from "../invitation/invitation.service";
import { Product } from "../market/_model/product.model";
import { CartService } from "../market/_services/cart.service";
import { ProductService } from "../market/_services/product.service";
import { ReportTask } from "../report/report-task/report-task.model";
import { ReportTaskService } from "../report/report-task/report-task.service";
import { Report } from "../report/report.model";
import { ReportService } from "../report/report.service";
import { SpaceAssignmentModel } from "src/app/_models/space-assignment.model";
import { TranslateService } from "@ngx-translate/core";
import { UserAssignmentViewComponent } from "../_component/_space/user-assignment-view/user-assignment-view.component";
import { SpaceBookingViewComponent } from "../_component/_space/space-booking-view/space-booking-view.component";
import SwiperCore, { Pagination } from "swiper";
import { UserSessionModel } from "src/app/_models/user-session.model";
import { getCommunityModel } from "src/app/_models/community-request.model";
import { InfoPage, InfoPageFab } from "./home.model";
import { addMinutes } from "date-fns";

SwiperCore.use([Pagination]);

@Component({
  selector: "app-home",
  templateUrl: "./home.page.html",
  styleUrls: [
    "./home.page.scss",
    "../../../../node_modules/swiper/swiper.scss",
    "../../../../node_modules/swiper/modules/pagination/pagination.scss",
  ],
  encapsulation: ViewEncapsulation.None,
  animations: [Animations.animeHeight, Animations.animeRotate],
})
export class HomePage implements OnInit, AfterViewInit, OnDestroy {
  constructor(
    public userServ: UserService,
    private tasksService: ReportTaskService,
    private config: ConfigService,
    private invitationServ: InvitationService,
    private bookingServ: BookingService,
    private productsService: ProductService,
    public communityService: CommunityService,
    private reportService: ReportService,
    public loadingController: LoadingController,
    private loaderService: LoaderService,
    private translate: TranslateService,
    public p: ThisPlatform,
    public authService: AuthService,
    public dictionaryServ: DictionaryService,
    private router: Router,
    public cartServ: CartService,
    private spaceService: SpaceService,
    private actionSheetController: ActionSheetController,
    public platform: Platform,
    private communityServ: CommunityService,
  ) {}

  @ViewChild("content", { read: ElementRef })
  contentElement: ElementRef;

  @ViewChild("tilesContainer")
  tilesContainer;

  bannerImageUrl: string;
  logoMobileUrl: string;
  userStorage: User;
  userName: string;
  statsInfoPages: InfoPage[] = [];
  statsInfoPagesFab: InfoPageFab[] = [];
  currentInfoPage: InfoPage;
  invitations: Invitation[];
  parkingAssignments: SpaceAssignmentModel[];
  parkingBookings: BookingModel[];
  bookings: BookingModel[];
  products: Product[];
  productsSortColumn = "ordersCount";
  communitySortColumn = "id";
  currentProduct: Product;
  communities: Community[];
  math = Math;
  userSession: UserSessionModel = new UserSessionModel();
  // Kiedy wartość równa jest 0, js uznaje to jako false i loader nie wyłącza się, dlatego poniższe zmienne muszą być stringami.
  userParkingAssignmentsCount = 0;
  userParkingBookingCount = 0;
  userInvitationsCount = 0;
  userTasksCount = 0;
  userReportsCount = 0;
  userReservationsCount = 0;
  userDeskBookingCount = 0;
  userDeskAssignmentsCount = 0;

  // zmienne dla zakupow
  productCounter: number;
  idProvider: number;

  showParkingAssignments: boolean = false;
  showParkingBookings: boolean = false;
  showInvitationList: boolean = false;
  showBookingList: boolean = false;
  showCommunityList: boolean = true;

  parkingAssignmentsLoaderSub = new EventEmitter();
  parkingBookingsLoaderSub = new EventEmitter();
  invitationLoaderSub = new EventEmitter();
  bookingsLoaderSub = new EventEmitter();

  permissionsLoaded: boolean = false;

  refreshing: boolean = false;
  invitationsLoad: boolean = false;
  productsLoad: boolean = false;

  loaderReleaseDelay: number = 150;

  componentRef: any = InvitationViewComponent;
  componentRefReservations: any = BookingViewComponent;
  componentRefParkingAssignment: any = UserAssignmentViewComponent;
  componentRefParkingBookings: any = SpaceBookingViewComponent;

  showLeftArrow: boolean = false;
  showRightArrow: boolean = true;

  logoUrl: string = "";
  public actualSubscription: Subscription = new Subscription();
  localeStorageSubscription: Subscription;

  today: Date = new Date();

  columnsDefinition: PaginationColumn[] = [
    {
      name: "company",
      displayName: "ADD_INVITATION.COMPANY",
      size: 2,
      sortable: true,
      colValue: (row) => {
        return row.user && row.user.company ? row.user.company.name : "-";
      },
    },
    {
      name: "host",
      displayName: "INVITATION.HOST",
      size: 2,
      sortable: true,
      colValue: (row) => {
        return row.user.firstName;
      },
    },
    {
      name: "guests",
      displayName: "INVITATION.GUESTS_NUMBER",
      size: 1,
      sortable: true,
      colValue: (row) => {
        return row.invitationGuests.length;
      },
    },
    {
      name: "title",
      displayName: "INVITATION.INV_NAME",
      size: 3,
      sortable: true,
    },
    {
      name: "dateStart",
      displayName: "INVITATION.DATE",
      size: 2,
      sortable: true,
    },
    {
      name: "time",
      displayName: "INVITATION.TIME",
      size: 2,
      sortable: true,
    },
  ];

  columnsDefinitionBookings: PaginationColumn[] = [
    {
      name: "picture",
      displayName: "",
      size: 2,
      sortable: false,
    },
    {
      name: "room",
      displayName: "MENU.ROOM",
      size: 2,
      sortable: true,
      colValue: (row) => {
        return row.bookingSpaces[0].space.name;
      },
    },
    {
      name: "startTime",
      displayName: "MENU.DATE",
      size: 2,
      sortable: true,
    },
    {
      name: "title",
      displayName: "MENU.TITLE",
      size: 6,
      sortable: true,
    },
  ];

  columnsDefinitionParkingAssignments: PaginationColumn[] = [
    {
      name: "picture",
      displayName: "SPACE.VIEW",
      size: 1,
      sortable: false,
    },
    {
      name: "building",
      displayName: "SPACE.BUILDING",
      size: 1,
      sortable: false,
    },
    {
      name: "level",
      displayName: "SPACE.LEVEL",
      size: 1,
      sortable: false,
    },
    {
      name: "place",
      displayName: "SPACE.PLACE",
      size: 2,
      sortable: false,
    },
    {
      name: "startDate",
      displayName: "SPACE.RESERVATION_START",
      size: 2,
      sortable: false,
    },
    {
      name: "endDate",
      displayName: "SPACE.RESERVATION_END",
      size: 5,
      sortable: false,
    },
  ];

  columnsDefinitionParkingBookings: PaginationColumn[] = [
    {
      name: "picture",
      displayName: "SPACE.VIEW",
      size: 1,
      sortable: false,
    },
    {
      name: "building",
      displayName: "SPACE.BUILDING",
      size: 1,
      sortable: false,
    },
    {
      name: "level",
      displayName: "SPACE.LEVEL",
      size: 1,
      sortable: false,
    },
    {
      name: "place",
      displayName: "SPACE.PLACE",
      size: 1,
      sortable: false,
    },
    {
      name: "startDate",
      displayName: "SPACE.RESERVATION_START",
      size: 2,
      sortable: false,
    },
    {
      name: "endDate",
      displayName: "SPACE.RESERVATION_END",
      size: 2,
      sortable: false,
    },
    {
      name: "number",
      displayName: "SPACE.PARKING.PLATE_NUMBER",
      size: 2,
      sortable: false,
    },
    {
      name: "name",
      displayName: "SPACE.ASSIGNED_PERSON",
      size: 2,
      sortable: false,
    },
    {
      name: 'status',
      displayName: 'MENU.STATUS',
      size: 3,
      sortable: true,
      colValue: (row) => {
        return row.status
      },
    },
  ];

  slideOpts = {
    speed: 600,
    pagination: {
      el: ".swiper-pagination",
      type: "bullets",
      clickable: true,
    },
    breakpoints: {
      320: {
        slidesPerView: 1.1,
        freeModeSticky: true,
        freeMode: true,
        spaceBetween: 0,
        allowTouchMove: true,
      },
      640: {
        centerInsufficientSlides: true,
        allowTouchMove: true,
        spaceBetween: 0,
        slidesPerView: 2.1,
      },
    },
  };

  headerInit: HeaderModel = {
    title: "COMMUNITY.COMMUNITY",
  };

  invitationsRowsLoader: RowsLoaderService;
  parkingAssignmentsRowsLoader: RowsLoaderService;
  parkingBookingsRowsLoader: RowsLoaderService;
  bookingsRowsLoader: RowsLoaderService;

  options: PaginationClientSideOptions = {
    ...new PaginationClientSideOptions(),
    overrideCountTranslation: "ADD_INVITATION.INVITATIONS_",
    hideMobileHeader: true,
    headerStickyPosition: "disabled",
  };

  optionsMyAssignments: PaginationClientSideOptions = {
    ...new PaginationClientSideOptions(),
    mobileViewBreakPoint: 1200,
    noResultsText: "SPACE.PARKING.NO_ASSIGNED_PARKING_SPACE",
    hideMobileHeader: true,
    headerStickyPosition: "disabled",
    customData: "hidePlateNumber",
    spaceType: SpaceType.Parking,
  };

  optionsMyBookings: PaginationClientSideOptions = {
    ...new PaginationClientSideOptions(),
    mobileViewBreakPoint: 1200,
    noResultsText: "SPACE.NO_RESERVATIONS",
    hideMobileHeader: true,
    headerStickyPosition: "disabled",
    spaceType: SpaceType.Parking,
    gridColumnsCount: 15
  };

  communitiesQuantity: number = 3;
  appModule = AppModule;

  readonly includedParkingBookingStatuses: ReadonlyArray<BookingStatus> = [BookingStatus.New, BookingStatus.Confirmed, BookingStatus.RegistredEntry];

  async ngOnInit() {
    this.screenCalc();

    this.cartServ
      .getCartItemCount()
      .asObservable()
      .subscribe((e: number) => {
        this.productCounter = e;
      });

    this.platform.ready().then(() => {
      this.platform.resume.subscribe(async () => {
        this.refresh();
      });
    });

    this.localeStorageSubscription = this.authService
      .getUserDataFromLocalStorage()
      .subscribe((userSession: UserSessionModel) => {
        this.userSession = userSession;
      });
  }

  doRefresh(event) {
    this.refreshing = this.platform.is("ios");
    this.refresh();

    setTimeout(() => {
      event.target.complete();
      this.refreshing = false;
    }, 2000);
  }

  refresh() {
    this.refreshParkingAssignments();
    this.refreshParkingBookings();
    this.refreshInvitations();
    this.refreshTasks();
    this.refreshReports();
    this.refreshProducts();
    this.refreshCommunities();
    this.refreshDeskBooking();
    this.refreshDeskAssignments();
    this.communityServ.getUnreadCommunities(
      CommunityType.IntegrationTrip, AppModule.IntegrationTrip
    );
  }

  async ionViewWillEnter() {
    this.authService.getUserDataFromLocalStorage();
    await this.userServ.getPermision();

    let url = await this.config.getConfigValue("main_page_banner_link");

    this.logoMobileUrl = await this.config.getConfigValue(
      "home_page_logo_mobile_url"
    );

    let banerLogoUrl; //await this.config.getConfigValue("home_page_logo_url");

    this.logoUrl = banerLogoUrl ? banerLogoUrl : "/assets/images/logo-full.png";

    this.userName = this.userServ.userStorage.firstName;

    if (this.permissionsLoaded === false) {
      await this.userServ.getPermision();
      this.permissionsLoaded = true;
    }

    this.statsInfoPages = [
      {
        ordinalNumber: 1,
        name: "invitationsMy",
        titleTranslation: "MENU.MY_INVITATIONS",
        redirectLink: "/app/invitation",
        addEndpoint: "/app/invitation/add-invitation",
        addLinkTitleTranslationDesktop: "MENU.ADD_INVITATION",
        addLinkTitleTranslationMobile: "MENU.ADD_INVITATION",
        icon: "assets/icons/menu/virtual-reception.svg",
        count: () => {
          return this.userInvitationsCount.toString();
        },
        viewRole: "invitation.view.mine",
        addRole: "invitation.add",
        idModule: AppModule.Reception,
      },
      {
        ordinalNumber: 2,
        name: "reportsMy",
        titleTranslation: "MENU.MY_OPEN_REPORTS",
        redirectLink: "/app/report",
        addEndpoint: "/app/report/add-report/0",
        addLinkTitleTranslationDesktop: "MENU.ADD_REPORT",
        addLinkTitleTranslationMobile: "MENU.ADD_REPORT",
        iconname: "clipboard-outline",
        count: () => {
          return this.userReportsCount.toString();
        },
        viewRole: "reports.view",
        addRole: "report.add",
        idModule: AppModule.Reports,
      },
      {
        ordinalNumber: 3,
        name: "tasksMy",
        titleTranslation: "MENU.MY_OPEN_TASKS",
        redirectLink: "/app/report-task",
        addEndpoint: "",
        addLinkTitleTranslationDesktop: "MENU.ADD_TASK",
        addLinkTitleTranslationMobile: "MENU.ADD_TASK",
        iconname: "document-text-outline",
        count: () => {
          return this.userTasksCount.toString();
        },
        viewRole: "reporttask.mytask",
        addRole: "false",
        idModule: AppModule.Reports,
      },
      {
        ordinalNumber: 4,
        name: "invitationsAll",
        titleTranslation: "MENU.BOOKING_ROOMS",
        // redirectLink: "/app/booking/my-reservation",
        redirectLink: "/app/booking",
        addEndpoint: "/app/booking",
        addEndpointQueryParam: "book",
        addLinkTitleTranslationDesktop: "MENU.ADD_RESERVATION",
        addLinkTitleTranslationMobile: "BOOKING.BOOK_A_ROOM",
        icon: "assets/icons/menu/rezerwacja.svg",
        count: () => {
          return this.userReservationsCount.toString();
        },
        viewRole: "booking.view",
        addRole: "booking.edit.allOwners",
        idModule: AppModule.Booking,
      },
      {
        ordinalNumber: 5,
        name: "parkingAll",
        titleTranslation: "MENU.PARKING",
        redirectLink: "/app/parking",
        addEndpoint: "/app/parking/add-reservation",
        addLinkTitleTranslationDesktop: "SPACE.ADD_RESERVATION",
        addLinkTitleTranslationMobile: "SPACE.PARKING.BOOK_A_PARKING",
        icon: "assets/icons/menu/parking1.svg",
        count: () => {
          return (
            this.userParkingAssignmentsCount + this.userParkingBookingCount
          );
        },
        viewRole: "parking.segment.reservations-view",
        addRole: "parking.my-reservations.add",
        idModule: AppModule.Parking,
      },
      {
        ordinalNumber: 6,
        name: "SPACE.DESK",
        titleTranslation: "MENU.DESK",
        redirectLink: "/app/desk",
        addEndpoint: "/app/desk/add-reservation",
        addLinkTitleTranslationDesktop: "SPACE.DESK.BOOK_DESK",
        addLinkTitleTranslationMobile: "SPACE.DESK.BOOK_DESK",
        icon: "assets/icons/menu/desk.svg",
        count: () => {
          return this.userDeskBookingCount + this.userDeskAssignmentsCount;
        },
        viewRole: "desk.view",
        addRole: "desk.spaces.add-edit",
        idModule: AppModule.Desk,
      },
    ];

    this.parseFabIcons();

    //Check box module is available for user
    this.statsInfoPages = this.statsInfoPages.filter((x) =>
      this.checkModule(x.idModule)
    );

    if (this.statsInfoPages.length > 0) {
      this.currentInfoPage = this.statsInfoPages[0];
    }

    if (url) {
      this.bannerImageUrl = url;
    } else {
      this.bannerImageUrl = "../../assets/images/banner.jpg";
    }

    this.refreshTasks();
    this.refreshReports();
    this.refreshProducts();
    this.refreshCommunities();
  }

  parseFabIcons() {
    this.statsInfoPagesFab = this.statsInfoPages
      .filter((page) => page.addEndpoint && this.userServ.hasRoles([page.viewRole]))
      .map((page) => {
        return {
          text: this.translate.instant(page.addLinkTitleTranslationMobile),
          icon: page.icon ? page.icon : page.iconname,
          order: page.ordinalNumber,
          handler: () => {
            this.router.navigateByUrl(page.addEndpoint);
          },
        };
      });

    this.statsInfoPagesFab.push({
      text: this.translate.instant("CLOSE"),
      icon: "close",
      role: "cancel",
    });
  }

  ngAfterViewInit(): void {}

  async ionViewDidEnter() {
    this.bookingServ.type = BookingSection.MyBookingFuture;

    if (this.permissionsLoaded === false) {
      await this.userServ.getPermision();
      this.permissionsLoaded = true;
    }
    this.subscribeEvents();

    this.refreshParkingAssignments();
    this.refreshParkingBookings();
    this.refreshInvitations();
    this.refreshTasks();
    this.refreshReports();
    this.refreshDeskBooking();
    this.refreshDeskAssignments();

    this.bookingServ.reloadBooking();

    this.showLeftArrow = false;
    this.showRightArrow = true;
  }

  ionViewDidlLeave() {
    this.actualSubscription.unsubscribe();
  }

  parkingBookingsRowsLoaderInitSub() {
    if (this.parkingBookingsRowsLoader) {
      this.parkingBookingsRowsLoaderInit();
    } else {
      this.parkingBookingsLoaderSub.subscribe(() => {
        this.parkingBookingsRowsLoaderInit();
      });
    }
  }

  parkingBookingsRowsLoaderInit() {
    this.parkingBookingsRowsLoader.init(this.parkingBookings);
  }

  parkingAssignmentsRowsLoaderInitSub() {
    if (this.parkingAssignmentsRowsLoader) {
      this.parkingAssignmentsRowsLoaderInit();
    } else {
      this.parkingAssignmentsLoaderSub.subscribe(() => {
        this.parkingAssignmentsRowsLoaderInit();
      });
    }
  }

  parkingAssignmentsRowsLoaderInit() {
    this.parkingAssignmentsRowsLoader.init(this.parkingAssignments);
  }

  invitationsRowsLoaderInitSub() {
    if (this.invitationsRowsLoader) {
      this.invitationsRowsLoaderInit();
    } else {
      this.invitationLoaderSub.subscribe(() => {
        this.invitationsRowsLoaderInit();
      });
    }
  }

  invitationsRowsLoaderInit() {
    this.invitationsRowsLoader.init(this.invitations);
  }

  bookingsRowsLoaderInitSub() {
    if (this.bookingsRowsLoader) {
      this.bookingRowsLoaderInit();
    } else {
      this.bookingsLoaderSub.subscribe(() => {
        this.bookingRowsLoaderInit();
      });
    }
  }

  bookingRowsLoaderInit() {
    this.bookingsRowsLoader.init(this.bookings);
  }

  updateReservations(data) {
    if (data === "refresh") {
      this.refreshParkingBookings();
    }
  }

  //TODO dodać endpoint zwracjący liczba tasków i ewentualnie liczba zaproszeń

  refreshTasks() {
    if (
      this.checkModule(AppModule.Reports) &&
      this.userServ.checkRoles(["reporttask.mytask"])
    ) {
      const request: GetReportTasksModel = {
        performedBy: this.userServ.userStorage.id,
        closed: "false",
      };
      this.tasksService.getReportTasks(request).subscribe(
        (reportTasks: ReportTask[]) => {
          this.userTasksCount = reportTasks.length;
        },
        (err) => {
          this.loaderService.loaderError = err;
        }
      );
    }
  }

  refreshParkingAssignments() {
    if (
      this.checkModule(AppModule.Parking) &&
      this.userServ.checkRoles(["parking.segment.reservations-view"])
    ) {
      let requestDetails: GetAssignmentsModel = {
        spaceType: SpaceType.Parking,
        idUser: this.userServ.userStorage.id,
        full: "true",
        endTimeGreatherThan: new Date(new Date()).toISOString(),
      };

      this.spaceService
        .getAssignments(requestDetails)
        .subscribe((res: SpaceAssignmentModel[]) => {
          this.userParkingAssignmentsCount = res.length;
          this.showParkingAssignments = res.length > 0;
          this.parkingAssignments = res.slice(0, 3);
          this.parkingAssignmentsRowsLoaderInitSub();
        });
    }
  }

  async refreshParkingBookings() {
    if (
      this.checkModule(AppModule.Parking) &&
      this.userServ.checkRoles(["parking.segment.reservations-view"])
    ) {
      let requestParams: GetBookingByUserModel = {
        spaceType: SpaceType.Parking,
        idUserOwner: this.userServ.userStorage.id,
        order: "ASC",
        endTimeGreatherThan: addMinutes(new Date, -30).toISOString(),
      };

      this.bookingServ
        .getBookingByUser(requestParams)
        .subscribe((res: BookingModel[]) => {
          this.userParkingBookingCount = res.length;
          this.setParkingBookings(res);
          this.showParkingBookings = this.parkingBookings.length > 0;
          this.parkingBookingsRowsLoaderInitSub();
        });
    }
  }

  refreshDeskAssignments() {
    if (
      this.checkModule(AppModule.Desk) &&
      this.userServ.checkRoles(["desk.view"])
    ) {
      let requestParams: GetAssignmentsModel = {
        spaceType: SpaceType.Desk,
        idUser: this.userServ.userStorage.id,
        full: "true",
        endTimeGreatherThan: new Date(new Date()).toISOString(),
      };

      this.spaceService
        .getAssignments(requestParams)
        .subscribe((res: SpaceAssignmentModel[]) => {
          this.userDeskAssignmentsCount = res.length;
        });
    }
  }

  refreshDeskBooking() {
    if (
      this.checkModule(AppModule.Desk) &&
      this.userServ.checkRoles(["desk.view"])
    ) {
      let requestParams: GetBookingByUserModel = {
        spaceType: SpaceType.Desk,
        idUserOwner: this.userServ.userStorage.id,
        order: "ASC",
        endTimeGreatherThan: new Date(new Date()).toISOString(),
      };

      this.bookingServ
        .getBookingByUser(requestParams)
        .subscribe((res: BookingModel[]) => {
          this.userDeskBookingCount = res.length;
        });
    }
  }

  async refreshInvitations() {
    this.today.setHours(0, 0, 0, 0);
    if (
      this.checkModule(AppModule.Reception) &&
      this.userServ.checkRoles(["invitation.view.mine"])
    ) {
      let requestParams: GetInvitationsQuery = {
        all: false,
        dateEndGreatherThan: this.today.toISOString(),
        order: "ASC",
      };
      this.invitationServ.getInvitations(requestParams).subscribe(
        (invitations: Invitation[]) => {
          this.invitationsLoad = true;
          this.checkLoaderDismiss();

          this.userInvitationsCount = invitations.length;
          this.showInvitationList = invitations.length > 0;
          this.invitations = invitations.slice(0, 3);

          this.invitationsRowsLoaderInitSub();
        },
        (err) => {
          this.statsInfoPages = this.statsInfoPages.filter(
            (x) => x.name !== "invitationsMy"
          );
          this.loaderService.loaderError = err;
        }
      );
    }
  }

  refreshBookings(bookings: any) {
    if (
      this.checkModule(AppModule.Booking) &&
      this.userServ.checkRoles(["booking.view"])
    ) {
      this.userReservationsCount = bookings.length;

      this.showBookingList = bookings.length > 0;
      this.bookings = bookings.slice(0, 3);

      this.bookingsRowsLoaderInitSub();
    }
  }

  refreshReports() {
    if (
      this.checkModule(AppModule.Reports) &&
      this.userServ.checkRoles(["reports.view"])
    ) {
      this.reportService
        .getReports({
          idUserCreatedBy: this.userServ.userStorage.id,
          closed: "false",
        })
        .subscribe(
          (reports: Report[]) => {
            this.userReportsCount = reports.length;
          },
          (err) => {
            this.loaderService.loaderError = err;
          }
        );
    }
  }

  refreshProducts() {
    if (
      this.checkModule(AppModule.Market) &&
      this.userServ.checkRoles(["market.view"])
    ) {
      this.productsService.getProducts(3, "DESC").subscribe(
        (products: Product[]) => {
          this.productsLoad = true;
          this.checkLoaderDismiss();

          this.products = products;
        },
        (err) => {
          this.loaderService.loaderError = err;
        }
      );
    }
  }

  refreshCommunities() {
    if (
      this.checkModule(AppModule.Community) &&
      this.userServ.checkRoles(["community.view"])
    ) {
      if (window.innerWidth < this.p.pageBrakepointSmallDesktop) {
        this.communitiesQuantity = 3;
      } else {
        this.communitiesQuantity = 4;
      }

      let requestParams: getCommunityModel = {
        limit: this.communitiesQuantity,
        home: true
      }

      this.communityService
        .getcommunities(requestParams)
        .subscribe((communities: Community[]) => {
          this.communities = communities;
          this.showCommunityList = communities.length > 0 ? true : false;
        });
    }
  }

  async presentActionSheet() {
    const actionSheet = await this.actionSheetController.create({
      buttons: this.statsInfoPagesFab,
    });
    await actionSheet.present();
  }

  checkModule(moduleId: number) {
    return this.userServ.userStorage?.modules.some(
      (i) => i.idModule == moduleId
    );
  }

  parkingBookingsRowsLoaderServiceReady(loader: RowsLoaderService) {
    this.parkingBookingsRowsLoader = loader;
    this.parkingBookingsLoaderSub.emit();
  }

  parkingAssignmentsRowsLoaderServiceReady(loader: RowsLoaderService) {
    this.parkingAssignmentsRowsLoader = loader;
    this.parkingAssignmentsLoaderSub.emit();
  }

  invitationRowsLoaderServiceReady(loader: RowsLoaderService) {
    this.invitationsRowsLoader = loader;
    this.invitationLoaderSub.emit();
  }

  bookingRowsLoaderServiceReady(loader: RowsLoaderService) {
    this.bookingsRowsLoader = loader;
    this.bookingsLoaderSub.emit();
  }

  checkLoaderDismiss() {
    if (
      this.productsLoad &&
      this.invitationsLoad &&
      !this.loaderService.loaderError
    ) {
      window.setTimeout(() => {
        this.loaderService.hideLoading();
      }, this.loaderReleaseDelay);
    }
  }

  subscribeEvents() {
    this.actualSubscription = this.bookingServ.bookingsSubject.subscribe(
      (p) => {
        this.refreshBookings(p);
      }
    );
  }

  toggleCommunity() {
    this.userSession.homeHideCommunity = !this.userSession.homeHideCommunity;
    this.authService.updateUserDataInLocalStorage(this.userSession);
  }

  toggleProducts() {
    this.userSession.homeHideProducts = !this.userSession.homeHideProducts;
    this.authService.updateUserDataInLocalStorage(this.userSession);
  }

  toggleInvitations() {
    this.userSession.homeHideInvitations = !this.userSession
      .homeHideInvitations;
    this.authService.updateUserDataInLocalStorage(this.userSession);
  }

  toggleParkingAssignments() {
    this.userSession.homeHideParkingAssignments = !this.userSession
      .homeHideParkingAssignments;
    this.authService.updateUserDataInLocalStorage(this.userSession);
  }
  toggleParkingBookings() {
    this.userSession.homeHideParkingBookings = !this.userSession
      .homeHideParkingBookings;
    this.authService.updateUserDataInLocalStorage(this.userSession);
  }
  toggleBookings() {
    this.userSession.homeHideBookings = !this.userSession.homeHideBookings;
    this.authService.updateUserDataInLocalStorage(this.userSession);
  }

  onShowCart(event: number) {
    this.idProvider = event;
  }
  onCartClick(): void {
    this.router.navigateByUrl("/app/market/cart/" + this.idProvider);
  }

  screenCalc() {
    if (window.matchMedia("(max-width: 1199px)").matches) {
      this.communitiesQuantity = 3;
    } else {
      this.communitiesQuantity = 4;
    }
  }
  
  private setParkingBookings(res: BookingModel[]) {
    this.parkingBookings = res.filter(e => this.includedParkingBookingStatuses.some(f => f === e.status)).slice(0, 3);
  }

  ngOnDestroy(): void {
    this.localeStorageSubscription.unsubscribe();
  }
}
